import React, {FC} from 'react'
import Spinner from 'react-spinkit'
import * as S from './styles'

interface ILoader{
    size?: number,
    className?: string,
    color?: string,
    withPadding?: boolean
}

const Loader:FC<ILoader> = ({size, color="#0E4C54", withPadding=true, className}) => {

    return(
        <S.Loader withPadding={withPadding} className={className}>
            <Spinner
                fadeIn="none"
                name="circle"
                color={color}
                style={{
                height: size || undefined,
                width: size || undefined,
                }}
            />
        </S.Loader>
    )
}

export default Loader